import { FC } from 'react'

import { Markdown } from '../atoms'
import { IoArrowDown } from 'react-icons/io5'
import {
    colors,
    LanguageCode,
    privacyAndSecurityURL,
} from '@hazadapt-git/public-core-base'
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Link,
} from '@mui/material'
import {
    infoUsageDisclaimerText,
    InfoUsageDisclaimerTextConfig,
} from '../../i18n'

interface InfoUsageDisclaimerProps {
    lang?: LanguageCode
}

export const InfoUsageDisclaimer: FC<InfoUsageDisclaimerProps> = ({ lang }) => {
    const modalConfig: InfoUsageDisclaimerTextConfig | undefined =
        infoUsageDisclaimerText.get(lang ?? LanguageCode.ENGLISH)

    return modalConfig ? (
        <Accordion>
            <AccordionSummary
                expandIcon={
                    <IoArrowDown
                        size={'1.5rem'}
                        color={colors.grays.THUNDERCLOUD}
                    />
                }
                aria-controls="panel1-content"
                id="panel1-header"
            >
                <Markdown content={modalConfig.title} />
            </AccordionSummary>
            <AccordionDetails>
                <Markdown content={modalConfig.body} />
                <Link href={privacyAndSecurityURL} target="_blank">
                    {modalConfig.linkText}
                </Link>
            </AccordionDetails>
        </Accordion>
    ) : null
}
